import { Link } from 'react-router-dom';
import './AboutUs.css';
import teamImage from '../assets/images/about-who-we-are.jpg';
import heroImage from '../assets/images/about-hero-image.png';

const values = [
  {
    title: 'AI Digital Personas',
    desc: 'Engage next-generation influencers tailored to your brand’s personality, audience, and values. From lifelike avatars with distinct personalities to custom AI software, we blend creativity and technology to redefine how brands show up in the digital world.',
  },
  {
    title: 'AI Digital Content Development',
    desc: 'Partner with our team to create AI-powered content that expands your online presence and engages your audience—from reels, still images, and posts to short- and long-form videos.',
  },
  {
    title: 'Mobile Apps',
    desc: 'Our team builds iOS and Android mobile apps that help clients connect with customers anytime, anywhere.',
  },
  {
    title: 'Digital Design Studio',
    desc: 'We create thoughtful digital experiences and content that strengthen your business and make a meaningful difference for users.',
  },
];

const stats = [
  { value: 'Decades', label: 'of technology and digital marketing experience with marketers and brands.' },
  { value: 'Global', label: 'reach across FMCG verticals and regions.' },
  { value: 'One', label: 'dedicated team from ideation, strategy to execution.' },
];

function AboutUs() {
  return (
    <>
      <section className="about-hero">
        <div className="container about-hero-content">
          <div className="about-hero-text">
            <span className="eyebrow eyebrow-light">About Us</span>
            <div className="about-hero-stat">
              <span className="about-hero-stat-value">65%</span>
              <p className="about-hero-stat-label">
                of CMOs believe advances in AI will dramatically transform their
                role within the next few years.
              </p>
            </div>
            <h1>
              A team of experienced technologists, digital marketers,
              developers, and builders&hellip;..
            </h1>
            <p className="section-lead">
              BCA Ventures is a new AI enabled digital experience company
              bringing together experienced AI and digital professionals to
              create online content, personas, and applications leading the
              charge into the next stage of the digital revolution.
            </p>
          </div>
          <img className="about-hero-image" src={heroImage} alt="" />
        </div>
      </section>

      <section className="section" id="who-we-are">
        <div className="container about-grid">
          <div>
            <h2 className="section-heading about-who-heading">Who We Are</h2>
            <h3 className="about-subheading">
              AI is redefining how organizations grow and compete.
            </h3>
            <p className="about-lead">
              We are AI-First Digital Marketing Strategists, executing
              intelligent systems, campaigns, and applications for our internal
              operations as well as on behalf of clients.
            </p>
            <p>
              Our team designs and produces AI-powered digital personas for
              brands. From custom digital avatars and AI influencers to digital
              twins and campaign-ready virtual models, we help brands build
              scalable digital presence across advertising, social media and
              brand activations. Our approach combines creative direction,
              technology and production to deliver high impact digital
              campaigns and assets.
            </p>
            <p>
              We develop both mobile and web applications for our clients as
              well as market our own applications across the web, Apple iOS
              and Android platforms.
            </p>
          </div>

          <div className="about-stats-col">
            <div
              className="about-photo"
              style={{ backgroundImage: `url(${teamImage})` }}
            />
            <div className="about-stats">
              {stats.map((stat) => (
                <div className="about-stat" key={stat.label}>
                  <span className="about-stat-value">{stat.value}</span>
                  <span className="about-stat-label">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="section section-alt" id="core-values">
        <div className="container">
          <h2 className="section-heading">Capabilities and Focus Areas</h2>

          {/* Four items: two per row */}
          <div className="grid grid-2 values-grid">
            {values.map((item) => (
              <div className="card" key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section cta">
        <div className="container cta-inner">
          <h2>Let&apos;s work together&hellip;</h2>
          <p className="section-lead">
            Tell us about your business and where you want to take it.
          </p>
          <Link to="/contact-us" className="btn btn-primary">
            Contact Us
          </Link>
        </div>
      </section>
    </>
  );
}

export default AboutUs;
